import MenuCoreUI from './MenuCoreUI';

export default MenuCoreUI;
